"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { Menu, X } from "lucide-react";
import Links from "@/utils/links";

import "./styles.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen((open) => !open);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header id="header">
      <div>
        <p className="logo">
          <svg
            role="img"
            aria-label="Bandera de Panamá"
            width="40"
            height="30"
            viewBox="0 0 40 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="15" fill="#ffffff" />
            <rect x="20" width="20" height="15" fill="#d52b1e" />
            <rect y="15" width="20" height="15" fill="#0033a0" />
            <rect x="20" y="15" width="20" height="15" fill="#ffffff" />
            <polygon
              points="10,5 11,8 14,8 11.5,10 12.5,13 10,11 7.5,13 8.5,10 6,8 9,8"
              fill="#0033a0"
            />
            <polygon
              points="30,20 31,23 34,23 31.5,25 32.5,28 30,26 27.5,28 28.5,25 26,23 29,23"
              fill="#d52b1e"
            />
          </svg>
          <Link href="/" aria-label="Inicio" itemProp="name">
            MAID
          </Link>
        </p>
        {/* Menú principal */}
        <nav
          role="navigation"
          aria-label="Menú principal"
          id="main-menu"
          className={isMenuOpen ? "open" : ""}
        >
          <ul onClick={closeMenu}>
            <li>
              <Link href="/" title="Volver al inicio">
                Inicio
              </Link>
            </li>
            <li>
              <Link
                href="/servicios"
                title="Servicios de limpieza en la Ciudad de Panamá"
              >
                Servicios
              </Link>
            </li>
            <li>
              <Link
                href="/empresa-limpieza-profesional-panama"
                title="Conoce más sobre nuestra empresa"
              >
                Sobre Nosotros
              </Link>
            </li>
            <li>
              <Link
                href="http://blog.maidpanama.com"
                title="Blog de limpieza profesional"
                target="_blank"
                rel="noopener noreferrer"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                href="/contactar-servicio-limpieza-panama"
                title="Contáctanos para más información"
              >
                Contacto
              </Link>
            </li>
          </ul>
        </nav>

        <Link
          href={Links.reservar}
          title="Haz clic para cotizar el precio y reservar tu limpieza en la Ciudad de Panamá"
          aria-label="Haz clic para cotizar el precio y reservar tu limpieza en la Ciudad de Panamá"
          target="_blank"
          rel="noopener noreferrer"
          className="primary-gradient small"
        >
          <i className="fab fa-whatsapp fa-1x" aria-hidden="true"></i>
          Reservar
        </Link>

        {/* Menú hamburguesa visible solo en mobile */}
        <button
          className="menu-toggle"
          aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={isMenuOpen}
          aria-controls="main-menu"
          onClick={toggleMenu}
        >
          {isMenuOpen ? <X size={32} /> : <Menu size={32} />}
        </button>
      </div>
    </header>
  );
};

export default Header;